import React from 'react';
import styled from 'styled-components';
import { Text } from '@oneaudi/unified-web-components';
import { SYS_SPACE_RELATIVE_XL, SYS_SPACE_RELATIVE_LG } from '@oneaudi/unified-web-common';
import { useI18n } from '@oneaudi/i18n-context';

import { enableHTMLEntities } from '../../utils/enableHTMLEntities';

const StyledInfoRow = styled.div`
  padding-top: ${process.env.IS_LEGACY ? SYS_SPACE_RELATIVE_XL : SYS_SPACE_RELATIVE_LG};
`;

interface InfoRowProps {
  articleCredits?: string;
  articleReadingTime?: number;
  articleCreationDate?: string;
}

export const InfoRow: React.FC<InfoRowProps> = (props) => {
  const { articleCredits, articleReadingTime, articleCreationDate } = props;

  if (!articleCredits && !articleReadingTime && !articleCreationDate) {
    return null;
  }

  const textRowChunks: string[] = [];

  if (articleReadingTime) {
    textRowChunks.push(
      // eslint-disable-next-line react-hooks/rules-of-hooks
      useI18n({ id: 'fa.article-intro.reading-time' }, { duration: articleReadingTime }),
    );
  }

  if (articleCredits) {
    textRowChunks.push(enableHTMLEntities(articleCredits));
  }

  if (articleCreationDate) {
    textRowChunks.push(articleCreationDate);
  }

  return (
    <StyledInfoRow>
      <Text variant={{ type: 'copy', order: '2', style: 'normal' }}>
        {textRowChunks.join(enableHTMLEntities(' &ndash; '))}
      </Text>
    </StyledInfoRow>
  );
};

InfoRow.displayName = 'InfoRow';
